module.exports = __webpack_public_path__ + "img/i.5d6becc7.jpg";